import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { CentToEurDisplayDirective } from '@/directives/cent-to-eur-display.directive';
import { TicketPaperComponent } from './ticket-paper.component';

/** One ticket printed in thermal-receipt format. Shared by the single-ticket print route and the cash-closing print. */
@Component({
  selector: 'app-ticket-receipt',
  imports: [TicketPaperComponent, CentToEurDisplayDirective, DatePipe],
  templateUrl: './ticket-receipt.component.html',
})
export class TicketReceiptComponent {
  @Input() ticket: any = {};
  @Input() details: any[] = [];
  @Input() company: any = {};
  @Input() office: any = null;
  @Input() hidePrices = false;

  public paymentMethods: Record<string, string> = {
    efectivo: 'Efectivo',
    tarjeta: 'Tarjeta',
    mixto: 'Mixto',
    bizum: 'Bizum',
  };

  getPaymentMethodLabel(method: string): string {
    return this.paymentMethods[method] ?? method;
  }

  lineTotal(detail: any): number {
    return (detail.pivot?.price || 0) * (detail.pivot?.quantity || 0);
  }
}
